__turbopack_context__.v({
  "closing": "HeadshotLanding-module__RAUQYa__closing",
  "closingMark": "HeadshotLanding-module__RAUQYa__closingMark",
  "closingPortrait": "HeadshotLanding-module__RAUQYa__closingPortrait",
  "container": "HeadshotLanding-module__RAUQYa__container",
  "exampleLabel": "HeadshotLanding-module__RAUQYa__exampleLabel",
  "eyebrow": "HeadshotLanding-module__RAUQYa__eyebrow",
  "faqList": "HeadshotLanding-module__RAUQYa__faqList",
  "faqSection": "HeadshotLanding-module__RAUQYa__faqSection",
  "filters": "HeadshotLanding-module__RAUQYa__filters",
  "gallery": "HeadshotLanding-module__RAUQYa__gallery",
  "galleryImage": "HeadshotLanding-module__RAUQYa__galleryImage",
  "gallerySection": "HeadshotLanding-module__RAUQYa__gallerySection",
  "hero": "HeadshotLanding-module__RAUQYa__hero",
  "heroArtwork": "HeadshotLanding-module__RAUQYa__heroArtwork",
  "heroCopy": "HeadshotLanding-module__RAUQYa__heroCopy",
  "heroFootnote": "HeadshotLanding-module__RAUQYa__heroFootnote",
  "heroMain": "HeadshotLanding-module__RAUQYa__heroMain",
  "heroPhotos": "HeadshotLanding-module__RAUQYa__heroPhotos",
  "heroSide": "HeadshotLanding-module__RAUQYa__heroSide",
  "imageNote": "HeadshotLanding-module__RAUQYa__imageNote",
  "initials": "HeadshotLanding-module__RAUQYa__initials",
  "lede": "HeadshotLanding-module__RAUQYa__lede",
  "page": "HeadshotLanding-module__RAUQYa__page",
  "photoStamp": "HeadshotLanding-module__RAUQYa__photoStamp",
  "plan": "HeadshotLanding-module__RAUQYa__plan",
  "planName": "HeadshotLanding-module__RAUQYa__planName",
  "planPrice": "HeadshotLanding-module__RAUQYa__planPrice",
  "plans": "HeadshotLanding-module__RAUQYa__plans",
  "plus": "HeadshotLanding-module__RAUQYa__plus",
  "pricingSection": "HeadshotLanding-module__RAUQYa__pricingSection",
  "pricingToolbar": "HeadshotLanding-module__RAUQYa__pricingToolbar",
  "primaryButton": "HeadshotLanding-module__RAUQYa__primaryButton",
  "processExample": "HeadshotLanding-module__RAUQYa__processExample",
  "processLayout": "HeadshotLanding-module__RAUQYa__processLayout",
  "processSection": "HeadshotLanding-module__RAUQYa__processSection",
  "purchaseNote": "HeadshotLanding-module__RAUQYa__purchaseNote",
  "rangeLabels": "HeadshotLanding-module__RAUQYa__rangeLabels",
  "rating": "HeadshotLanding-module__RAUQYa__rating",
  "resultPhotos": "HeadshotLanding-module__RAUQYa__resultPhotos",
  "reviewGrid": "HeadshotLanding-module__RAUQYa__reviewGrid",
  "reviews": "HeadshotLanding-module__RAUQYa__reviews",
  "secondaryButton": "HeadshotLanding-module__RAUQYa__secondaryButton",
  "sectionHeading": "HeadshotLanding-module__RAUQYa__sectionHeading",
  "sectionNav": "HeadshotLanding-module__RAUQYa__sectionNav",
  "skipLink": "HeadshotLanding-module__RAUQYa__skipLink",
  "smallRule": "HeadshotLanding-module__RAUQYa__smallRule",
  "stepNumber": "HeadshotLanding-module__RAUQYa__stepNumber",
  "steps": "HeadshotLanding-module__RAUQYa__steps",
  "studioName": "HeadshotLanding-module__RAUQYa__studioName",
  "teamPlan": "HeadshotLanding-module__RAUQYa__teamPlan",
  "teamTotal": "HeadshotLanding-module__RAUQYa__teamTotal",
  "textLink": "HeadshotLanding-module__RAUQYa__textLink",
  "transformationLine": "HeadshotLanding-module__RAUQYa__transformationLine",
  "uploadPhotos": "HeadshotLanding-module__RAUQYa__uploadPhotos",
  "useCases": "HeadshotLanding-module__RAUQYa__useCases",
});
